import { CardDash } from '../CardDash';
import { useEffect, useState } from '@wordpress/element';
import { SearchPorPalavraChave } from '../SearchPorPalavraChave';
import HeaderTable from '../../../../componentsNew/Table/HeaderTable';
import SemDadosAnalise from '../../../DicasOtimizacao/AnalisesTextuais/Components/SemDadosAnalise';
import ItemTable from '../../../../componentsNew/Table/ItemTable';
import Pagination from '@componentsNew/Pagination';
import { useGetMetrics } from '@pages/Dashboard/customHooks';
import CircularProgress from '@componentsNew/CircularProgress';

export function ResultadoPalavraChave({ artigoIds }) {
  const [metricasPaginadas, setMetrics] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [metricasFiltradas, setMetricasFiltradas] = useState(metricasPaginadas || []);

  const redimensionarDiv = () => {
    let elemento = document.getElementById('grafico_dash');
    document.getElementById(
      'lista_palavra_dash'
    ).style.height = `calc(${elemento.offsetHeight}px - 7.4rem)`;
  };

  useEffect(() => {
    if (artigoIds !== undefined && artigoIds.length > 0) {
      useGetMetrics(artigoIds, setMetrics, setMetricasFiltradas, setIsLoading);
    }
  }, [artigoIds]);

  useEffect(() => {
    redimensionarDiv();
  }, [metricasPaginadas, metricasFiltradas]);

  return (
    <CardDash className="w-3/5" id="resultado_palavra_dash">
      <SearchPorPalavraChave
        metricasPaginadas={metricasPaginadas?.metricas}
        setMetricasFiltradas={setMetricasFiltradas}
        onChange={redimensionarDiv}
        className="mt-6"
      />

      <div className="overflow-auto mt-6 flex flex-col justify-between" id="lista_palavra_dash">
        <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left">
          <thead className="pb-6">
            <tr className="flex w-full bg-neutras-grey-light rounded-lg py-2 px-6 uppercase gap-12 text-text-primary">
              <HeaderTable className="w-2/6">PALAVRA-CHAVE</HeaderTable>
              <HeaderTable className="w-1/6">POSIÇÃO</HeaderTable>
              <HeaderTable className="w-1/6">NOTA SEO</HeaderTable>
              <HeaderTable className="w-2/6">VOLUME DE BUSCA</HeaderTable>
            </tr>
          </thead>

          <tbody className="divide-y divide-fundo-borda-grafico w-full">
            {metricasFiltradas.length > 0 ? (
              metricasFiltradas?.map(m => (
                <tr key={m.id} className="flex w-full px-6 py-[0.625rem] gap-12">
                  <ItemTable className="w-2/6">{m?.palavra}</ItemTable>
                  <ItemTable className="w-1/6">
                    {m?.posicao != 0 && m?.posicao != null
                      ? `Top ${m?.posicao == 31 ? '30+' : m?.posicao}`
                      : '-'}
                  </ItemTable>
                  <ItemTable className="w-1/6">{m?.seo?.toFixed(1)}</ItemTable>
                  <ItemTable className="w-2/6">{m?.volume}</ItemTable>
                </tr>
              ))
            ) : (
              <tr className="min-h-[15.438em] items-center justify-center flex h-full">
                {isLoading ? (
                  <td className="min-h-[15.438em] justify-center items-center w-full h-full flex">
                    <CircularProgress component="" size={64} />
                  </td>
                ) : (
                  <td>
                    <SemDadosAnalise texto="Adicione um artigo com uma palavra-chave para iniciar avaliação das palavras vinculadas" />
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        <div>
          <Pagination
            totalPaginas={
              Math.ceil(metricasPaginadas?.totalDeRegistros / metricasPaginadas?.tamanhoDaPagina) ||
              0
            }
            paginaAtual={metricasPaginadas?.paginaAtual || 0}
            itemPorPagina={metricasPaginadas?.tamanhoDaPagina || 0}
            onPageChange={page =>
              useGetMetrics(
                metricasPaginadas?.artigoIds,
                setMetrics,
                setMetricasFiltradas,
                setIsLoading,
                page,
                metricasPaginadas?.tamanhoDaPagina
              )
            }
          />
        </div>
      </div>
    </CardDash>
  );
}
